module.exports = __webpack_public_path__ + "f321b36fc494840253c550817407bf4a.pdf";